/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { SelectDropdown } from 'tc-client-common';
import { getSelectedFilter } from '../utils';

const getSelectedStatusFilter = (filters) => (filtersByStatus) =>
  getSelectedFilter(filters)(filtersByStatus, 'status', 'All statuses');

const ParticipantStatusFilter = ({ appliedFilters, onStatusChange, filtersByStatus }) => (
  <SelectDropdown
    id="participant-status-selector"
    selectedValue={getSelectedStatusFilter(appliedFilters)(filtersByStatus)}
    onChange={onStatusChange}
    options={filtersByStatus}
  />
);

ParticipantStatusFilter.propTypes = {
  appliedFilters: PropTypes.object,
  onStatusChange: PropTypes.func,
  filtersByStatus: PropTypes.array
};

export default ParticipantStatusFilter;
